const ThemeType = {
    DEFAULT: 'DEFAULT',
    WEATHER: 'WEATHER'
};

export default ThemeType;